import $ from 'jquery';
import { message } from './function'
import CONFIG from './config'
const conf: any = CONFIG;

function request(method: string, url: string, params: any, option: any) {
  return new Promise(function (resolve, reject) {
    url = conf.api + url;
    let query = {
      p: 'wechat',
      v: 'v5.0.0',
    }

    if (query) {
      url += '?' + $.param(query);
    }
    const ajaxOptions = {
      data: params,
      method: method || 'POST',
      url,
      timeout: 20000,
      headers: {
        "Content-Type": option.contentType || 'application/x-www-form-urlencoded; charset=UTF-8',
        userType: 'B',
        p: 'wechat',
        deviceType: 'wechat',
        v: 'v5.0.0',
      },

      dataType: option.dataType || 'json',
      processData: option.processData || true,
      beforeSend(xhr: any) {
        option.beforeSend && option.beforeSend(xhr);
      },
      success(res: any) {
        // debugger
        if (res.success || res.resultCode === 0) {
          resolve(res);
        } else if (res.resultCode == 1) {
        } else if (res.code == 'LOGIN_OVERDUE') {
          reject(res)
        } else {
          processRequestError(res);
          reject(res)
        }
      },
      error(xhr: any) {
        // if (xhr.status == 401 || xhr.status == 403) {
        //   if (location.href.indexOf('login') !== -1) {
        //     reject(xhr);
        //   }
        // } else {
        //   processHttpError(xhr);
        //   reject(xhr);
        // }
      }
    }

    $.ajax(ajaxOptions);
    // }
  });

}

function processRequestError(res: any) {
  message(res.message || res.resultMsg);
}

function processHttpError(xhr: any) {
 if (xhr.status == 400) {
    message('请正确填写数据！错误码（400）');
  } else if (xhr.status == 500) {
    message('服务端发生错误！错误码（500）');
  } else if (xhr.status == 404) {
    message('服务端未处理该请求！错误码（404）');
  } else {
    message('服务端开小差了，请稍后再试~');
  }
}

function sobotRequest(action:string, data:any) {
  const param = {
    action,
    data,
    access_token: localStorage.getItem("access_token")
  }
  const url = 'https://sobot.xiaomai5.com/open/platform/api.json'
  return new Promise(function (resolve, reject) {
    const ajaxOptions = {
      data: JSON.stringify(param),
      method: 'POST',
      url,
      timeout: 20000,
      headers: {
        "Content-Type": 'application/json; charset=UTF-8',
      },

      dataType: 'json',
      processData: true,
      success(res: any) {
        resolve(res);
      },
      error(res: any) {
        reject(res)
      }
    }

    $.ajax(ajaxOptions);
  })
}


class Axios {
  static get(url: string, params = {}, option = {}) {
    return request('get', url, params, option);
  }
  static post(url: string, params = {}, option = {}) {
    return request('post', url, params, option);
  }
  static postJSON(url: string, params: any = {}, option: any = {}) {
    option = option || {};
    option.contentType = 'application/json; charset=UTF-8';
    return request('post', url, JSON.stringify(params), option);
  }

  static sobot(action: string, data: any) {
    return sobotRequest(action, data)
  }

}


export default Axios;